exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.mobile-video-witness[data-v-7323c24a],.mobile-video-witness .white-box[data-v-7323c24a]{height:100%\n}", "", {"version":3,"sources":["/home/jenkins/workspace/pipeline-10323-UAT-kmos-web-ci-cd-6005/html/PC/src/components/imageNode/mobile_video_witness.vue"],"names":[],"mappings":";AACA,yFAAyF,WAAW;CACnG","file":"mobile_video_witness.vue","sourcesContent":["\n.mobile-video-witness[data-v-7323c24a],.mobile-video-witness .white-box[data-v-7323c24a]{height:100%\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7323c24a","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/style-rem-loader??ref--1!./src/components/imageNode/mobile_video_witness.vue
// module id = 1218
// module chunks = 2